/**
 * Версия схемы состояния. ЕДИНОЕ имя оси схемы — `version` (D24/R11;
 * `stateSchemaVersion` упразднён). Миграции — пост-MVP (tech/25 §4).
 */
export const CURRENT_STATE_VERSION = 9;
//# sourceMappingURL=types.js.map